<template>
  <div :class="wrapClass" v-if="visible">
    <div class="gkui-dialog-mask" @click="handleMask"></div>
    <transition :name="transitionName">
      <div class="gkui-dialog-container" :style="mainStyle" v-if="contentVisible">
        <span class="gkui-dialog-close" @click="close" v-if="hasClose"></span>
        <div class="gkui-dialog-header" v-if="showHead">
          <slot name="header">
            {{title}}
          </slot>
        </div>
        <div class="gkui-dialog-body">
          <slot />
        </div>
        <div class="gkui-dialog-footer">
          <slot name="footer">
            <Button size="normal" :color="cancelBtnColor" @click="cancel" v-if="hasCancel">{{cancelText}}</Button>
            <Button size="normal" :color="okBtnColor" @click="ok" :useLock="true">
              <template slot="status" slot-scope="{locked}" >
                <Loading class="gkui-dialog-loading" color="white" size="14px" v-if="loading && locked" />
              </template>
              {{okText}}
            </Button>
          </slot>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import VueTypes from 'vue-types'

import Button from '../button'
import Loading from '../loading'
export default {
  name: 'gkui-dialog',
  components: {
    Button,
    Loading
  },
  props: {
    value: VueTypes.bool.def(false),
    name: VueTypes.string,
    transitionName: VueTypes.string.def('modal-zoom-in'),
    title: VueTypes.string,
    dialogClass: VueTypes.string,
    mask: VueTypes.bool.def(true),
    maskClickClose: VueTypes.bool.def(true),
    center: VueTypes.bool.def(false),
    hasClose: VueTypes.bool.def(true),
    verticalCenter: VueTypes.bool.def(false),
    width: VueTypes.number.def(520),
    top: VueTypes.oneOfType([Number, String]).def(100),
    hasCancel: VueTypes.bool.def(true),
    handleOk: {type: Function},
    handleCancel: {type: Function},
    okText: VueTypes.string.def('确定'),
    cancelText: VueTypes.string.def('取消'),
    okBtnColor: VueTypes.string.def('blue'),
    cancelBtnColor: VueTypes.string.def('transparent'),
    loading: VueTypes.bool.def(false)
  },
  data () {
    return {
      showHead: true,
      visible: false,
      contentVisible: false
    }
  },
  computed: {
    mainStyle () {
      let style = {}
      const width = parseInt(this.width)
      const styleWidth = {
        width: width <= 100 ? `${width}%` : `${width}px`,
        top: typeof this.top === 'string' ? this.top : `${this.top}px`
      }
      const customStyle = this.styles ? this.styles : {}
      Object.assign(style, styleWidth, customStyle)

      return style
    },
    wrapClass () {
      return [
        'gkui-dialog',
        {
          'gkui-dialog-can-close': this.maskClickClose && this.mask,
          'gkui-dialog-center': this.center,
          'gkui-dialog-vertical-center': this.verticalCenter
        },
        this.dialogClass
      ]
    }
  },
  watch: {
    value (show) {
      if (this.mask) {
        show ? this.$modal.showLayer() : this.$modal.hideLayer()
      }

      if (show) {
        this.visible = show
        this.$nextTick(() => {
          this.contentVisible = show
        })
      } else {
        this.contentVisible = show
        setTimeout(() => {
          this.visible = show
        }, 300)
      }
    }
  },
  created () {
  },
  mounted () {
    // 函数调用时 设置了value 当组件挂在之后 设置 visible 和 contentVisible = true,  使内容部分做动画显示
    this.visible = this.value
    this.$nextTick(() => {
      this.contentVisible = this.value
    })
    let showHead = true
    if (this.$slots.header === undefined && !this.title) {
      showHead = false
    }

    this.showHead = showHead
  },
  methods: {
    close () {
      this.$emit('input', false)
      this.$emit('cancel')
    },
    async ok ({clear}) {
      if (this.loading) {
        // 如果是 需要 loading 状态，则把 关闭方法 传递出去
        if (this.handleOk) {
          await this.handleOk({clear, close: this.destroy})
        }
        this.$emit('ok', {clear})
        return
      }

      if (this.handleOk) {
        await this.handleOk({clear, close: this.destroy})
        return
      }
      this.$emit('input', false)
      this.$emit('ok', {clear})
    },
    async cancel () {
      if (this.handleCancel) {
        await this.destroy()
        this.handleCancel({close: this.close})
        return
      }
      this.close()
    },
    handleMask () {
      if (this.mask && this.maskClickClose) {
        this.close()
      }
    },
    destroy () {
      this.contentVisible = false
      setTimeout(() => {
        this.visible = false
        this.hideLayer().then(() => {
          this.$modal.hide(this.name)
          return true
        })
      }, 100)
    },
    hideLayer () {
      return new Promise((resolve, reject) => {
        this.$modal.hideLayer()
        resolve()
      })
    }
  }
}
</script>

